import { HeaderSkeleton, SkeletonRegion, TableSkeleton } from '@ems/ui/patterns/skeleton-blocks'

export function TicketTypesSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-32" description="w-64" actions={['h-9 w-36']} />
      <TableSkeleton
        columns={[
          { cell: 'mono', widths: ['w-16', 'w-20'] },
          { cell: 'text', widths: ['w-40', 'w-32', 'w-48'], primary: true },
          { cell: 'muted', widths: ['w-20', 'w-24'] },
          { cell: 'text', widths: ['w-24', 'w-20'], align: 'end' },
          { cell: 'mono', widths: ['w-16', 'w-12'] },
          { cell: 'mono', widths: ['w-32', 'w-28'], header: 'w-24' },
          { cell: 'badge', widths: ['w-16'] },
          { cell: 'icon', header: null, align: 'end', shrink: true },
        ]}
      />
    </SkeletonRegion>
  )
}
